import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { qb_performance } from "../../gql/queries";
import { useParams, Link, useNavigate, useLocation } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import moment from "moment";
import { testPerformanceTest, transform } from "../../utils";
import Modal from "react-bootstrap/Modal";
import ReactStars from "react-rating-stars-component";
import { ToastContainer, toast } from 'react-toastify';

import {
    Chart as ChartJS,
    CategoryScale,
    ArcElement,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { firebaseData } from "../../firebase";
import { Star_Bookmark } from "../../gql/mutation";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import { decrypt } from "../../utils/crypto";
import ConnectionError from "../common/NoDataFound/ConnectionError";
import { trackEvent } from "../../../src/utils/moengageUserSetup";
ChartJS.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);
const INITIAL_STATE = {
    feedback: "",
}
export default function QbPerformance() {
    const completePathUrl = useLocation()
    let { id, name } = useParams()
    const [config, setConfig] = useState();
    const [remoteLoading, setRemoteLoading] = useState(true);
    const naviagte = useNavigate()
    const [rating, setRating] = useState(false);
    const [getDetails, Details] = useState(INITIAL_STATE);
    const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    const showRating = () => setRating(true);
    const hideRating = () => setRating(false);
    const [star, setData] = useState(0)
    const [getBookmark] = useMutation(Star_Bookmark, {
        refetchQueries: [
            {
                query: qb_performance,
                variables: {
                    "_id": id,
                },
            }, // DocumentNode object parsed with gql
            'performanceSummeryQB' // Query name,

        ],
    });
    const query1 = useQuery(qb_performance, {
        variables: {
            "_id": id,
        },
        onCompleted: (data) => {
            console.log(data)
            trackEvent("viewPerformance", {

                "type": "qb", "content_id": id
            });
        },
    });
    useEffect(() => {
        const getConfigData = async () => {
            try {
                const remoteData = await firebaseData('performance_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
                setConfig(JSON.parse(remoteData));
                setRemoteLoading(false);
            } catch (error) {
                console.error('Error fetching remote data:', error);
                setRemoteLoading(false);
            }
        };

        if (typeof window !== 'undefined') {
            getConfigData();
        }
    }, []);
    trackEvent("ViewedWebPage", {
        url: window.location.href,
        timestamp: Date.now(),
    });
    if (query1.loading) return (<><Loader /></>)
    if (query1.error) {
        if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            authorizationCheck(naviagte)
        }
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={completePathUrl.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={completePathUrl.pathname} />
                    </div>
                </div>
            </>)

        }
        console.log(query1.error)
    }
    const pieoptions = {
        responsive: true,
        plugins: {
            datalabels: {
                display: false,
                color: "#27387D",
                anchor: "end",
                offset: -32,
                align: "start",
                // padding: {
                //   right: 0
                // },
                labels: {
                    padding: { top: 0 },
                    title: {
                        font: {
                            weight: "bold"
                        }
                    },
                    //   value: {
                    //     color: "green"
                    //   }
                },
                formatter: function (value) {
                    return "\n" + Math.round(value);
                }
            },
            legend: {
                display: false,
                position: 'top',
            },
            title: {
                display: false,
                text: 'Chart.js Bar Chart',
            },
        },
    };
    const Piedata = {
        // labels: ['', ''],
        datasets: [
            {
                data: [query1.data.qb.progress ? query1.data.qb.progress.attemptedQuesCount : 0, ((query1.data.qb ? query1.data.qb.questions.length : 0) - (query1.data.qb.progress ? query1.data.qb.progress.attemptedQuesCount : 0))],
                backgroundColor: [
                    'rgba(239, 242, 250, 1)',
                    'rgba(39, 56, 125, 1)'
                ],
                borderWidth: 0,
                // borderColor: '#EFF2FA'
            },
        ],
    };
    const correctData = {
        // labels: ['', ''],
        datasets: [
            {
                data: [query1.data.qb.progress ? query1.data.qb.progress.correctQuestions : 0, ((query1.data.qb ? query1.data.qb.questions.length : 0) - (query1.data.qb.progress ? query1.data.qb.progress.correctQuestions : 0))],
                backgroundColor: [
                    'rgba(226, 255, 237, 1)',
                    'rgba(70, 184, 115, 1)',
                ],
                borderWidth: 0,
                // borderColor: '#E2FFED'
            },
        ],
    };
    const incorrectData = {
        // labels: ['', ''],
        datasets: [
            {
                data: [query1.data.qb.progress ? query1.data.qb.progress.incorrectQuestions : 0, ((query1.data.qb ? query1.data.qb.questions.length : 0) - (query1.data.qb.progress ? query1.data.qb.progress.incorrectQuestions : 0))],
                backgroundColor: [
                    'rgba(255, 222, 222, 1)',
                    'rgba(220, 63, 22, 1)'
                ],
                borderWidth: 0,
                // borderColor: '#FFDEDE'
            },
        ],
    };
    const unansweredData = {
        // labels: ['', ''],
        datasets: [
            {
                data: [query1.data.qb.progress ? query1.data.qb.progress.unattemptedQids.length : 0, ((query1.data.qb ? query1.data.qb.questions.length : 0) - (query1.data.qb.progress ? query1.data.qb.progress.unattemptedQids.length : 0))],
                backgroundColor: [
                    'rgba(241, 241, 241, 1)',
                    'rgba(156, 156, 156, 1)'
                ],
                borderWidth: 0,
                // borderColor: '#F1F1F1'
            },
        ],
    };
    let exist = false
    const secondExample = {
        size: 20,
        count: 5,
        color: "#27387D",
        activeColor: "#ffd700",
        value: star,
        a11y: true,
        isHalf: false,
        emptyIcon: <i className="far fa-star" />,
        halfIcon: <i className="fa fa-star-half-alt" />,
        filledIcon: <i className="fa fa-star" />,
        onChange: newValue => {
            if (newValue <= 3) {
                setData(newValue)
                setRating(true)
            }
            else {
                setData(newValue)
                setRating(false)
                getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb?.progress?._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: "", subjectId: query1.data.qb.subject, courseName: course.preparingFor, "status": true, rating: newValue, feedback: '' } })
            }
        }
    }

    const firstExample = {
        size: 20,
        count: 5,
        color: "#27387D",
        activeColor: "#ffd700",
        value: Math.floor(query1.data && query1.data.qb?.progress?.rating),
        a11y: true,
        edit: false,
        isHalf: false,
        emptyIcon: <i className="far fa-star" />,
        halfIcon: <i className="fa fa-star-half-alt" />,
        filledIcon: <i className="fa fa-star" />,
        // onChange: newValue => {
        // }
    }

    const handleInputChange = function (fieldValue, fieldName) {
        Details({ ...getDetails, [fieldName]: fieldValue })
    }

    const submitBookmark = async (e) => {
        e.preventDefault();
        getBookmark({ variables: { resultId: query1.data.qb.progress ? query1.data.qb.progress._id : "", qbId: query1.data.qb._id, resultType: "Qb", questionId: "", subjectId: query1.data.qb.subject, courseName: course.preparingFor, "status": true, rating: star, feedback: getDetails.feedback } }).then(res => {
            if (res.data.bookmarkQuestionOrQbTest) {
                toast.success('Thank you for your feedback');
                setRating(false)
                Details(INITIAL_STATE)
                setData(0)
            }
        }).catch(res => {
            const errors = res.graphQLErrors.map(err => err.message);
            console.log(errors)
        })
    }


    return (
        <>
            <div className="main_wrapper">
                <ToastContainer />
                <div className="breadcrumbs">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item"><a >Home</a></li>
                        {/* <li className="breadcrumb-item"><a >QBank</a></li>
                    <li className="breadcrumb-item"><a >Anatomy</a></li>
                    <li className="breadcrumb-item"><a >Cranial Nerve Nuclei & Columns</a></li> */}
                        <li className="breadcrumb-item active"><a >Performance Summary</a></li>
                    </ul>
                </div>
                <section className="videoLayer_wrapper testPerformance_wrapper qbPerformance section_side_padding">
                    <div className='row'>
                        <div className="col-lg-8 col-md-7 col-sm-12">
                            <div className="subjects_wrapper">
                                <div className="setting_ttl_wrapper d-flex align-items-center">
                                    <figure className="sett_back_arrow">
                                        <Link to={`/qblayer/qbinstructions/${id}/${name}`}>
                                            <img src={Icons.BackArrow} alt="" className="img-fluid" />
                                        </Link>
                                    </figure>
                                    <div className="sett_ttl">
                                        <h5>Performance Summary</h5>
                                    </div>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper">
                                <div className="test_result_report">
                                    <h6>{query1.data.qb ? query1.data.qb.title : ''}</h6>
                                    <p className="completion_date">Completed on:<span> {moment(query1.data.qb.progress ? query1.data.qb.progress.endTime : '').format('MMM DD YYYY')}, at {moment(query1.data.qb?.progress ? query1.data.qb.progress?.endTime : '').format('hh:mm a')}</span></p>
                                    <p className="total_marks"><span className="number">{query1.data.qb ? query1.data.qb.questions.length : 0}</span>Questions<span className="dots"></span></p>
                                </div>
                                <div className="result_report_performance">
                                    <ul type="none" className="result_report d-flex align-items-center flex-wrap">
                                        <li>
                                            <div className="result_percentage d-flex align-items-center">
                                                <figure className="percentage_img">
                                                    <img src={Icons.ResultPerc} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="perc_data">
                                                    <h6>{query1.data.qb && ((query1.data.qb?.progress?.marks / query1.data.qb?.progress?.totalMarks) * 100) > 0 ? Math.round((query1.data.qb?.progress?.marks / query1.data.qb?.progress?.totalMarks) * 100) : 0}%</h6>
                                                    <p>Percentage</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="result_percentage d-flex align-items-center">
                                                <figure className="percentage_img">
                                                    <img src={Icons.ResultAccu} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="perc_data">
                                                    <h6>{query1.data.qb && Math.round(query1.data?.qb?.progress?.accuracy * 100)}%</h6>
                                                    <p>Accuracy</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="result_percentage d-flex align-items-center">
                                                <figure className="percentage_img">
                                                    <img src={Icons.ResultClock} alt="" className="img-fluid" />
                                                </figure>
                                                <div className="perc_data">
                                                    <h6>{Math.round(query1.data.qb.progress && (query1.data?.qb?.progress?.duration) / query1.data?.qb?.questions?.length)} seconds</h6>
                                                    <p>Avg Time/Que</p>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="recommended_video_wrapper">
                                <div className="test_result_report test_performance_rating d-flex align-items-center">
                                    <div className="rating_ttl">
                                        {
                                            (query1.data && query1?.data?.qb?.progress?.rating == 0 || query1?.data?.qb?.progress?.rating == null) &&
                                            <h6>How was your test experience?</h6>
                                        }
                                        {query1.data && query1?.data?.qb?.progress?.rating > 0 &&
                                            <h6>Thank you for your feedback</h6>
                                        }
                                    </div>
                                    {query1.data && query1?.data?.qb?.progress?.rating == 0 || query1?.data?.qb?.progress?.rating == null &&
                                        <div className="star_rating" >
                                            <ReactStars {...secondExample} classNames="hello_rate" />
                                        </div>
                                    }
                                    {query1.data && query1?.data?.qb?.progress?.rating > 0 &&
                                        <div className="star_rating">
                                            <ReactStars {...firstExample} classNames="hello_rate" />
                                        </div>
                                    }
                                </div>
                            </div>
                            {
                                config && config?.banner_config?.qb?.map(obj => {
                                    if (exist !== true) {
                                        if (obj.percentage > testPerformanceTest(query1.data.qb && query1?.data?.qb?.progress) <= obj?.percentage) {
                                            exist = true
                                            return (<div className="banner_img"><img src={obj.image} alt="img" /></div>)
                                        }
                                    }
                                })
                            }
                            <div className="recommended_video_wrapper">
                                <div className="test_result_report result_analysis">
                                    <h6>Result Analysis <span className="question_count">{query1.data.qb ? query1.data?.qb?.questions?.length : 0} <span className="count_txt">Questions</span></span></h6>
                                </div>
                                <div className="analysis_performance">
                                    <ul type="none" className="analysis_report d-flex align-items-center flex-wrap">
                                        <li>
                                            <Link to={`/qblayer/qballsolution/${id}/${name}`} state={JSON.stringify('attempt')}>
                                                <div className="result_percentage">
                                                    <figure className="percentage_img">
                                                        <Pie data={Piedata} options={pieoptions} />
                                                    </figure>
                                                    <div className="perc_data">
                                                        <h6>{query1.data.qb.progress ? query1.data.qb.progress.attemptedQuesCount : 0}</h6>
                                                        <p>Attempted</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to={`/qblayer/qballsolution/${id}/${name}`} state={JSON.stringify('correct')}>
                                                <div className="result_percentage">
                                                    <figure className="percentage_img">
                                                        <Pie data={correctData} options={pieoptions} />
                                                    </figure>
                                                    <div className="perc_data">
                                                        <h6>{query1.data.qb.progress ? query1.data.qb.progress.correctQuestions : 0}</h6>
                                                        <p>Correct</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to={`/qblayer/qballsolution/${id}/${name}`} state={JSON.stringify('incorrect')}>
                                                <div className="result_percentage">
                                                    <figure className="percentage_img">
                                                        <Pie data={incorrectData} options={pieoptions} />
                                                    </figure>
                                                    <div className="perc_data">
                                                        <h6>{query1.data.qb.progress ? query1.data.qb.progress.incorrectQuestions : 0}</h6>
                                                        <p>InCorrect</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to={`/qblayer/qballsolution/${id}/${name}`} state={JSON.stringify('skip')}>
                                                <div className="result_percentage">
                                                    <figure className="percentage_img">
                                                        <Pie data={unansweredData} options={pieoptions} />
                                                    </figure>
                                                    <div className="perc_data">
                                                        <h6>{query1.data.qb.progress ? query1.data.qb.progress.unattemptedQids.length : 0}</h6>
                                                        <p>Unanswered</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="view_slution_btn text-center">
                                <Link to={`/qblayer/qballsolution/${id}/${name}`}>
                                    <button type="button" className="btn btn_theme" >View All Solution</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Modal
                show={rating}
                onHide={hideRating}
                backdrop="static"
                className="detail_modal modal_rating"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <h4>Rating</h4>
                        <span className="cross_icon">
                            <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={hideRating} />
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="rating_modal_body">
                        <div className="modal_rating">
                            <ReactStars {...secondExample} />
                        </div>
                        <div className="form-group">
                            <label htmlFor="">Please share your feedback</label>
                            <textarea name="" id="" rows="5" className="form-control" placeholder="Enter feedback" onChange={(e) => handleInputChange(e.target.value, 'feedback')} value={getDetails.feedback ?? ''}></textarea>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="rating_submit">
                        <button type="button" className="btn btn_theme btn_border" onClick={hideRating}>Cancel</button>
                        <button type="button" className="btn btn_theme" onClick={(e) => submitBookmark(e)}>Submit</button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}